export default "__VITE_ASSET__03697cf1__"